import * as types from '../actions/actionType';

const propertyReducerByMonth = (state = { isLoading: true }, action) => {
    switch (action.type) {
        case types.GET_PROPERTY_BY_MONTH:
            return {
                ...state,
                filters: {
                    startDate: action.startDate,
                    endDate: action.endDate,
                    lyStartDate: action.lyStartDate,
                    lyEndDate: action.lyEndDate,
                },
                isLoading: true,
            };
        case types.GET_PROPERTY_BY_MONTH_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default propertyReducerByMonth;
